import { IInRestaurantOrderLineItem } from 'generated/graphql-gateway';
import { isCombo, isItem } from 'utils/menu/is-menu-type';
import { PosVendors } from 'utils/vendor-config';

import {
  IInRestaurantRedemptionCart,
  IInRestaurantRedemptionCartEntry,
  IInRestaurantRedemptionEntryType,
  IRewardRedemption,
} from './hooks/use-in-restaurant-redemption-cart';

const getVendorConfigsByPosVendor = (
  cartEntry: IInRestaurantRedemptionCartEntry,
  posVendor: PosVendors | null
): IInRestaurantOrderLineItem['vendorConfigs'] => {
  let vendorConfigs = cartEntry.vendorConfigs;

  if (posVendor === PosVendors.NCR && cartEntry.type === IInRestaurantRedemptionEntryType.REWARD) {
    const { reward } = cartEntry.details as IRewardRedemption;
    // only the first incentive is the needed to send
    const incentive = reward.incentives?.[0];
    if (incentive) {
      if (isItem(incentive) && incentive?.vendorConfigs) {
        vendorConfigs = incentive.vendorConfigs;
      } else if (isCombo(incentive) && incentive?.mainItem?.vendorConfigs) {
        vendorConfigs = incentive?.mainItem?.vendorConfigs;
      }
    }
  }

  return vendorConfigs;
};

export const generateOrderLineItems = (
  cart: IInRestaurantRedemptionCart,
  posVendor: PosVendors | null
): Array<IInRestaurantOrderLineItem> =>
  cart.map((cartEntry: IInRestaurantRedemptionCartEntry) => {
    const { quantity, referenceId, incentiveId, type } = cartEntry;

    return {
      incentive: {
        id: incentiveId,
        type,
      },
      quantity,
      referenceId,
      vendorConfigs: getVendorConfigsByPosVendor(cartEntry, posVendor),
    };
  });
